<template>
  <div class="flex -mx-3 text-sm">
    <div class="flex-1 px-3">
      {{ $t('name') | capitalize }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ $t('impressions') | capitalize }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ $t('reach') | capitalize }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ $t('visits') | capitalize }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ $t('costPerClick') | capitalize }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ $t('conversions') | capitalize }}
    </div>
    <div class="w-24 px-3 text-center">
      {{ $t('spend') | capitalize }}
    </div>
    <div class="w-24 px-3">
      {{ $t('status') | capitalize }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratHeader',
};
</script>
